/**
 * Open one of the external social profiles in a new tab. Facebook shows a
 * heads-up first (it requires an account to view the page). Ported from the
 * Angular `GlobalVars.goToSocialLink`.
 */
export function openSocialLink(target: string): void {
  if (target === 'facebook') {
    window.alert('You are about to open Facebook. Please note you must have a Facebook account to see my page.');
    window.open('https://facebook.com/tylerwrennftw', '_blank');
  } else if (target === 'twitter') {
    window.open('https://twitter.com/tweettylerwrenn', '_blank');
  } else if (target === 'linkedin') {
    window.open('https://www.linkedin.com/in/tylerwrenn/', '_blank');
  }
}
